<template>
  <!-- 在线课程质量报告 -->
  <div class="analysisReport">
    <el-button type="primary" class="export" @click="exportPdf">导出pdf</el-button>
    <div class="analysisReport_box" ref="pdfContent">
      <div class="chart_box page-box">
        <div class="header_titles">
          <h1>
            《{{ header.courseName }}》{{ jd == 1 ? "服务课程质量季度报告" : "课程质量报告" }}
          </h1>
          <div class="number_time">
            <div>
              <span>所属资源库：{{ header.zykName }}（{{ header.zykNum }}）</span>
              <span>数据截止时间：{{ dataTime }}</span>
            </div>
            <p />
            <p />
          </div>
        </div>
        <div class="division">1.课程基本信息</div>
        <div class="basic">
          <p>课程名称：{{ header.courseName }}</p>
          <p>所属学校名称: {{ header.schoolName }}</p>
        </div>
        <div class="division m-top150">2.课程建设情况</div>
        <h4>2.1 课程引用资源类型分布</h4>
        <p>
          课程引用资源总数为{{ getUtils_Fun(courseQuoteResource.allResourceSum) }}个，其中<span
            v-for="(item, index) in courseQuoteResource.dataList"
            :key="index"
            >{{ item.name }}{{ item.value }}个<span
              v-if="index != courseQuoteResource.dataList.length - 1"
              >；</span
            ></span
          >，具体如图1所示：
        </p>
        <div class="standards_content echartsHeight">
          <circularChart
            :refId="'courseQuoteResourceChart'"
            :datas="courseQuoteResource.dataList"
            :colorName="1"
            :titleLeft="'32%'"
            :legendBackgroundColor="true"
            :legendLeft="'60%'"
            :circleSize="80"
            :legendListFontSize="30"
          />
        </div>
        <div class="chart_name">图1 课程引用资源类型占比</div>
        <h4 class="m-top150">2.2 课程引用试题情况</h4>
        <p>本课程引用试题总数为{{ getUtils_Fun(questionBank.total) }}道，建设情况如图2所示：</p>
        <div class="standards_content echartsHeight">
          <circularChart
            :refId="'courseQuoteResourceChart'"
            :datas="questionBank.dataList"
            :colorName="1"
            :titleLeft="'32%'"
            :legendBackgroundColor="true"
            :legendLeft="'60%'"
            :circleSize="80"
            :legendListFontSize="30"
          />
        </div>
        <div class="chart_name">图2 本课程引用试题总数</div>
      </div>

      <div class="chart_box page-box">
        <div class="division">3.课程应用情况</div>
        <h4>3.1 开课期数及选课情况</h4>
        <p>
          该课程开课期数为{{ application.totalPeriods }}期，选课人数{{
            getUtils_Fun(application.total)
          }}人，按选课人数排序如图3所示：
        </p>
        <div class="biaoge">
          <table
            border="1"
            cellpadding="0"
            cellspacing="0"
            width="100%"
            bordercolor="#fff"
            class="course"
          >
            <tr>
              <th>序号</th>
              <th>课程名称</th>
              <th>课程负责人</th>
              <th>选课人数</th>
              <th>占比</th>
              <th>开课时间</th>
              <th>课程类型</th>
            </tr>
            <tr
              v-for="(item, index) in application.dataList"
              :key="index"
              v-show="application.dataList.length > 0"
            >
              <td>{{ index + 1 }}</td>
              <td>{{ item.name }}</td>
              <td>{{ item.otherValue }}</td>
              <td>{{ parseInt(item.value) }}</td>
              <td>
                {{
                  ((parseInt(item.value) / application.total) * 100).toFixed(2) > 0
                    ? ((parseInt(item.value) / application.total) * 100).toFixed(2)
                    : 0
                }}%
              </td>
              <td>{{ item.createTime ? item.createTime.substring(0, 10) : "" }}</td>
              <td>{{ item.courseType }}</td>
            </tr>
            <tr v-show="application.dataList.length == 0" class="nothing">
              <td colspan="7">无</td>
            </tr>
          </table>
        </div>
        <div class="chart_name">图3 按选课情况排名（前10名）</div>
        <h4 class="m-top150">3.2 教师应用情况</h4>
        <p>教师在本课程发布相关作业测试情况如图4所示：</p>
        <div class="standards_content echartsHeight">
          <vcolumnarChart
            :refId="'assignmentsChart'"
            :datas="assignments.dataList"
            :transverseData="assignments.transverseData"
            :colorList="colorList"
            :innerText="'单位：次'"
            :seriesColor="true"
            :labelShow="true"
            :isExportTextColor="true"
            :isShowTextColor="true"
          />
        </div>
        <div class="chart_name">图4 教师发布作业测试情况</div>
        <p class="m-top150">教师在本课程具体互动情况如图5所示：</p>
        <div style="display: flex">
          <div class="standards_content echartsHeight">
            <vcolumnarChart
              :refId="'communicationChart'"
              :datas="communicationLeft.dataList"
              :transverseData="communicationLeft.transverseData"
              :colorList="colorList"
              :innerText="'单位：次'"
              :seriesColor="true"
              :labelShow="true"
              :axisLabelInterval="true"
              :isShowTextColor="true"
              :isExportTextColor="true"
            />
          </div>
          <div class="standards_content echartsHeight">
            <vcolumnarChart
              :refId="'communicationChart'"
              :datas="communicationRight.dataList"
              :transverseData="communicationRight.transverseData"
              :colorList="colorList"
              :innerText="'单位：次'"
              :seriesColor="true"
              :labelShow="true"
              :axisLabelInterval="true"
              :isShowTextColor="true"
              :isExportTextColor="true"
            />
          </div>
        </div>
        <div class="chart_name">图5 教师互动情况</div>
      </div>

      <div class="chart_box page-box">
        <h4 class="m-top150">3.3 学生应用情况</h4>
        <p>学生在本课程中访问各类型资源情况如图6所示：</p>
        <div class="standards_content echartsHeight">
          <tcolumnarChart
            :refId="'variousChart'"
            :datas="various.dataList"
            :transverseData="various.transverseData"
            :colorList="colorList"
            :seriesColor="true"
            :isShowTextColor="true"
            :isExportTextColor="true"
          />
        </div>
        <div class="chart_name">图6 学生访问资源情况</div>
        <p class="m-top150">
          在本课程中参与互动的学生数为{{
            getUtils_Fun(situationLeft.cyhdrs)
          }}人，具体情况如图7所示：
        </p>
        <div style="display: flex">
          <div class="standards_content echartsHeight">
            <vcolumnarChart
              :refId="'situationChart'"
              :datas="situationLeft.dataList"
              :transverseData="situationLeft.transverseData"
              :colorList="colorList"
              :innerText="'单位：次'"
              :seriesColor="true"
              :labelShow="true"
              :axisLabelInterval="true"
              :isExportTextColor="true"
              :isShowTextColor="true"
            />
          </div>
          <div class="standards_content echartsHeight">
            <vcolumnarChart
              :refId="'situationChart'"
              :datas="situationRight.dataList"
              :transverseData="situationRight.transverseData"
              :colorList="colorList"
              :innerText="'单位：次'"
              :seriesColor="true"
              :labelShow="true"
              :axisLabelInterval="true"
              :isShowTextColor="true"
              :isExportTextColor="true"
            />
          </div>
        </div>
        <div class="chart_name">图7 学生互动情况</div>
        <h4 class="m-top150">3.4 用户近一月日活情况</h4>
        <p>
          本课程近一年的总访问量是{{
            getUtils_Fun(monthlyLearning.courseResourceLog)
          }}次，访问人数为{{ getUtils_Fun(monthlyLearning.learningsCount) }}人；近一月访问量{{
            getUtils_Fun(monthlyLearning.monthLog)
          }}次，访问人数{{ getUtils_Fun(monthlyLearning.userCount) }}人，近一月日活情况如图8所示：
        </p>
        <div class="standards_content echartsHeight">
          <discountChart
            :refId="'monthlyLearningChart'"
            :datas="monthlyLearning.dataList"
            :transverseData="monthlyLearning.transverseData"
            :colorList="colorList"
            :legendList="monthlyLearning.legendList"
            :innerText="'单位：次'"
            :isShowTextColor="true"
            :isExportTextColor="true"
          />
        </div>
        <div class="chart_name">图8 用户近一月日活情况</div>
      </div>

      <div class="chart_box page-box">
        <h4>3.5 课程被院校使用情况</h4>
        <p>
          本课程被共计{{ differentSchools.learningUserAve }}所院校使用，其院校选课总人数有{{
            getUtils_Fun(differentSchools.total)
          }}人，选课人数排前10的学校如图9所示：
        </p>
        <div class="standards_content echartsHeight">
          <tcolumnarChart
            :refId="'differentSchoolsChart'"
            :datas="differentSchools.dataList"
            :transverseData="differentSchools.transverseData"
            :colorList="colorList"
            :seriesColor="true"
            :isShowTextColor="true"
            :isExportTextColor="true"
          />
        </div>
        <div class="chart_name">图9 院校选课人数排名情况</div>
        <div class="division m-top150">4. 课程建设任务进度跟踪</div>
        <h4>4.1 课程用户建设进度跟踪</h4>
        <div class="standards_content echartsHeight">
          <vcolumnarChart
            :refId="'userProgressChart'"
            :datas="userProgress.dataList"
            :transverseData="userProgress.transverseData"
            :colorList="colorList"
            :legendList="['监测平台值', '任务目标值']"
            :innerText="'单位：人'"
            :isShowTextColor="true"
            :isExportTextColor="true"
            :axisLabelInterval="true"
          >
          </vcolumnarChart>
        </div>
        <div class="chart_name">图10 用户建设进度跟踪情况</div>
        <h4 class="m-top150">4.2 课程资源建设进度跟踪</h4>
        <div class="standards_content echartsHeight">
          <vcolumnarChart
            :refId="'materialChart'"
            :datas="material.dataList"
            :transverseData="material.transverseData"
            :colorList="colorList"
            :legendList="['监测平台值', '任务目标值']"
            :innerText="'单位：条'"
            :isShowTextColor="true"
            :isExportTextColor="true"
            :axisLabelInterval="true"
          />
        </div>
        <div class="chart_name">图11 资源建设进度跟踪情况</div>
      </div>

      <div class="chart_box page-box">
        <h4>4.3 课程资源建设占比进度跟踪</h4>
        <div class="standards_content echartsHeight">
          <vcolumnarChart
            :refId="'materialResourcesChart'"
            :datas="materialResources.dataList"
            :transverseData="materialResources.transverseData"
            :colorList="colorList"
            :legendList="['监测平台值', '任务目标值']"
            :innerText="'单位：%'"
            :isShowTextColor="true"
            :isExportTextColor="true"
            :axisLabelInterval="true"
          >
          </vcolumnarChart>
        </div>
        <div class="chart_name">图12 资源建设占比进度跟踪情况</div>
        <el-backtop />
      </div>
    </div>
  </div>
</template>

<script>
import circularChart from "@/components/chart/circularChart.vue"; //引入圆形图表
import vcolumnarChart from "@/components/chart/vcolumnarChart.vue"; //引入竖向柱状图图表
import tcolumnarChart from "@/components/chart/tcolumnarChart.vue"; //引入横向柱状图图表
import discountChart from "@/components/chart/discountChart.vue"; //引入折现图图表
import pageToPDF from "@/utils/htmlToPdf.js";
export default {
  components: {
    circularChart,
    vcolumnarChart,
    tcolumnarChart,
    discountChart,
  },
  data() {
    return {
      jd: null,
      colorList: [
        "#3B85FB",
        "#FD398E",
        "#8B68F1",
        "#EE6F5E",
        "#E0D35F",
        "#5470C6",
        "#DE7E4B",
        "#DE524B",
      ], //柱状图或折线图的颜色
      header: {
        courseName: "",
        zykName: "",
        zykNum: "",
        zykStatus: "",
        cutoffTime: "",
        schoolName: "",
      },
      dataTime: "",
      // 2.1 课程引用资源类型分布
      courseQuoteResource: {
        dataList: [],
        allResourceSum: 0,
      },
      // 2.2 课程引用试题情况
      questionBank: {
        dataList: [],
        total: 0,
      },
      // 3.1 开课期数及选课情况
      application: {
        dataList: [],
        total: 0,
        totalPeriods: 0,
      },
      // 3.2 教师应用情况-图4
      assignments: {
        dataList: [],
        transverseData: [],
      },
      // 3.2 教师应用情况-图5左
      communicationLeft: {
        dataList: [],
        transverseData: [],
      },
      // 3.2 教师应用情况-图5右
      communicationRight: {
        dataList: [],
        transverseData: [],
      },
      // 3.3 学生应用情况-图6
      various: {
        dataList: [],
        transverseData: [],
      },
      // 3.3 学生应用情况-图7左
      situationLeft: {
        dataList: [],
        transverseData: [],
        cyhdrs: 0,
      },
      // 3.3 学生应用情况-图7右
      situationRight: {
        dataList: [],
        transverseData: [],
      },
      // 3.4 用户近一月日活情况
      monthlyLearning: {
        dataList: [],
        transverseData: [],
        legendList: [],
        learningsCount: 0,
        courseResourceLog: 0,
        userCount: 0,
        monthLog: 0,
      },
      // 3.5 课程被院校使用情况
      differentSchools: {
        dataList: [],
        transverseData: [],
        total: 0,
        learningUserAve: 0,
      },
      // 4.1 课程用户建设进度跟踪
      userProgress: {
        dataList: [],
        transverseData: [],
      },
      // 4.2 课程资源建设进度跟踪
      material: {
        dataList: [],
        transverseData: [],
      },
      // 4.3 课程资源建设占比进度跟踪
      materialResources: {
        dataList: [],
        transverseData: [],
      },
      loading: "", //是否导出加载中
    };
  },
  created() {
    if (this.$route.query) {
      this.jd = this.$route.query.jd;
      this.dataTime = this.$route.query.dataTime;
      this.header.zykName = decodeURIComponent(this.$route.query.zykName);
      this.header.courseName = decodeURIComponent(this.$route.query.courseName);
      this.header.cutoffTime = decodeURIComponent(this.$route.query.createtime);
      this.header.schoolName = decodeURIComponent(this.$route.query.schoolName);
    }
    this.getStudentTeacherReportDetailDom(); // 获取整体数据
    this.courseQuoteResourceDom(); // 2.1 课程引用资源类型分布
    this.questionBankDom(); // 2.2 课程引用试题情况
    this.applicationDom(); // 3.1 开课期数及选课情况
    this.assignmentsDom(); // 3.2 教师应用情况-图4
    this.communicationLeftDom(); // 3.2 教师应用情况-图5左
    this.communicationRightDom(); // 3.2 教师应用情况-图5右
    this.variousDom(); // 3.3 学生应用情况-图6
    this.situationLeftDom(); // 3.3 学生应用情况-图7左
    this.situationRigthDom(); // 3.3 学生应用情况-图7右
    this.monthlyLearningDom(); // 3.4 用户近一月日活情况
    this.differentSchoolsDom(); // 3.5 课程被院校使用情况
    this.userProgressDom(); // 4.1 课程用户建设进度跟踪
    this.materialDom(); // 4.2 课程资源建设进度跟踪
    this.materialResourcesDom(); // 4.3 课程资源建设占比进度跟踪
  },
  methods: {
    // 导出pdf文件
    exportPdf() {
      const lableList = document.getElementsByClassName("page-box");
      let name = this.header.zykName.split("(");
      let newName = "";
      let oldName = "";
      let zykName = "";
      if (name.length > 1) {
        newName = name[0];
        oldName = name[1].replace(")", "");
        zykName = `${newName}（原专业名称：${oldName}）`;
      } else zykName = this.header.zykName;
      pageToPDF(
        `${this.header.zykNum}_${zykName}_${this.header.courseName}_课程质量报告`,
        this.$refs.pdfContent,
        lableList
      );
    },
    // 处理数据
    getUtils_Fun(num) {
      const data =
        num > 100000000
          ? `${
              (num / 100000000).toFixed(2).toString().split(".")[1] === "00"
                ? (num / 100000000).toFixed(0)
                : (num / 100000000).toFixed(2)
            }亿`
          : num > 10000
          ? `${
              (num / 10000).toFixed(2).toString().split(".")[1] === "00"
                ? (num / 10000).toFixed(0)
                : (num / 10000).toFixed(2)
            }万`
          : num;
      return data;
    },
    // 获取整体数据
    getStudentTeacherReportDetailDom() {
      this.$axios
        .post(
          this.$apiurls.report_qualityReport_getCourseQualityReportDetail,
          this.header.courseName,
          {
            loading: false,
          }
        )
        .then((res) => {
          if (res.data) {
            this.header = res.data;
          }
        });
    },
    // 2.1 课程引用资源类型分布
    courseQuoteResourceDom() {
      this.$axios
        .post(
          this.$apiurls.report_qualityReport_getCourseQuoteResource,
          {
            courseName: this.header.courseName,
            zykid: sessionStorage.getItem("zykId"),
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          if (res.data) {
            var arrList = [];
            var total = 0;
            for (let i = 0; i < res.data.length; i++) {
              arrList.push({
                name: res.data[i].mediatype,
                value: res.data[i].num,
              });
              total += res.data[i].num;
            }
            this.courseQuoteResource.dataList = arrList;
            this.courseQuoteResource.allResourceSum = total;
          }
        });
    },
    // 2.2 课程引用试题情况
    questionBankDom() {
      this.$axios
        .post(
          this.$apiurls.report_qualityReport_getCourseMonthQuestionAddNum,
          {
            courseName: this.header.courseName,
            zykid: sessionStorage.getItem("zykId"),
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          if (res.data) {
            let total = 0;
            var arrList = [];
            for (let i = 0; i < res.data.length; i++) {
              total += res.data[i].num;
            }
            arrList.push({
              name: "本课程引用试题总数",
              value: total,
            });
            this.questionBank.total = total;
            this.questionBank.dataList = arrList;
          }
        });
    },
    // 3.1 开课期数及选课情况
    applicationDom() {
      this.$axios
        .post(
          this.$apiurls.report_qualityReport_getCourseQualityCourseNper,
          this.header.courseName,
          {
            loading: false,
          }
        )
        .then((res) => {
          if (res.data) {
            this.application.total = 0;
            this.application.totalPeriods = res.data.length;
            for (let i = 0; i < res.data.length; i++) {
              this.application.total += parseFloat(res.data[i].value);
            }
            this.application.dataList = res.data.slice(0, 10);
          }
        });
    },

    // 3.2 教师应用情况-图4
    assignmentsDom() {
      this.$axios
        .post(
          this.$apiurls.report_qualityReport_getCourseWork,
          {
            courseName: this.header.courseName,
            zykid: sessionStorage.getItem("zykId"),
            role: 1,
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          if (res.data) {
            for (var key in res.data) {
              this.assignments.transverseData.push(key);
              this.assignments.dataList.push(res.data[key]);
            }
          }
        });
    },
    // 3.2 教师应用情况-图5左
    communicationLeftDom() {
      this.$axios
        .post(
          this.$apiurls.report_qualityReport_getCourseInteraction,
          {
            courseName: this.header.courseName,
            zykid: sessionStorage.getItem("zykId"),
            role: 2,
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          if (res.data) {
            for (let key in res.data.chart) {
              this.communicationLeft.transverseData.push(key);
              this.communicationLeft.dataList.push(res.data.chart[key]);
            }
          }
        });
    },
    // 3.2 教师应用情况-图5右
    communicationRightDom() {
      this.$axios
        .post(
          this.$apiurls.report_qualityReport_getCourseInteraction,
          {
            courseName: this.header.courseName,
            zykid: sessionStorage.getItem("zykId"),
            role: 3,
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          if (res.data) {
            for (let key in res.data.chart) {
              this.communicationRight.transverseData.push(key);
              this.communicationRight.dataList.push(res.data.chart[key]);
            }
          }
        });
    },

    // 3.3 学生应用情况-图6
    variousDom() {
      this.$axios
        .post(
          this.$apiurls.report_qualityReport_getResourceTypeLogCountByCourseName,
          this.header.courseName,
          {
            loading: false,
          }
        )
        .then((res) => {
          if (res.data) {
            this.various.dataList = res.data.echartBaseVo.value;
            this.various.transverseData = res.data.echartBaseVo.name;
          }
        });
    },

    // 3.3 学生应用情况-图7左
    situationLeftDom() {
      this.$axios
        .post(
          this.$apiurls.report_qualityReport_getCourseInteraction,
          {
            courseName: this.header.courseName,
            zykid: sessionStorage.getItem("zykId"),
            role: 4,
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          if (res.data) {
            for (var key in res.data.chart) {
              this.situationLeft.transverseData.push(key);
              this.situationLeft.dataList.push(res.data.chart[key]);
            }
            this.situationLeft.cyhdrs = res.data.cyhdrs;
          }
        });
    },

    // 3.3 学生应用情况-图7右
    situationRigthDom() {
      this.$axios
        .post(
          this.$apiurls.report_qualityReport_getCourseInteraction,
          {
            courseName: this.header.courseName,
            zykid: sessionStorage.getItem("zykId"),
            role: 5,
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          if (res.data) {
            for (var key in res.data.chart) {
              this.situationRight.transverseData.push(key);
              this.situationRight.dataList.push(res.data.chart[key]);
            }
          }
        });
    },

    // 3.4 用户近一月日活情况
    monthlyLearningDom() {
      this.$axios
        .post(
          this.$apiurls.report_qualityReport_getDayOrMonthLive,
          {
            zykid: sessionStorage.getItem("zykId"),
            courseName: this.header.courseName,
            month: "2022-08",
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          if (res.data) {
            this.monthlyLearning.dataList = res.data.value;
            this.monthlyLearning.transverseData = res.data.name;
            this.monthlyLearning.legendList = [];
            this.monthlyLearning.learningsCount = res.data.learningsCount
              ? res.data.learningsCount
              : 0;
            this.monthlyLearning.courseResourceLog = res.data.courseResourceLog
              ? res.data.courseResourceLog
              : 0;
            this.monthlyLearning.userCount = res.data.userCount ? res.data.userCount : 0;
            this.monthlyLearning.monthLog = res.data.monthLog ? res.data.monthLog : 0;
          }
        });
    },

    // 3.5 课程被院校使用情况
    differentSchoolsDom() {
      this.$axios
        .post(this.$apiurls.report_qualityReport_getSchoolNperSituation, this.header.courseName, {
          loading: false,
        })
        .then((res) => {
          if (res.data) {
            let num = 0;
            for (let i = 0; i < res.data.echartBaseVo.name.length; i++) {
              num += parseFloat(res.data.echartBaseVo.value[i]);
            }
            this.differentSchools.total = num;
            this.differentSchools.dataList = res.data.echartBaseVo.value;
            this.differentSchools.transverseData = res.data.echartBaseVo.name;
            this.differentSchools.learningUserAve = res.data.learningUserAve;
          }
        });
    },

    // 4.1 课程用户建设进度跟踪
    userProgressDom() {
      this.$axios
        .post(
          this.$apiurls.getConstructionProgressOfParticipatingInstitutionEcharts,
          {
            echartsType: 6,
            name: this.header.courseName,
            type: 2,
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          if (res.code === 200) {
            this.publicHandle(res.data, this.userProgress);
          }
        });
    },

    // 4.2 课程资源建设进度跟踪
    materialDom() {
      this.$axios
        .post(
          this.$apiurls.getConstructionProgressOfParticipatingInstitutionEcharts,
          {
            echartsType: 9,
            name: this.header.courseName,
            type: 2,
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          if (res.code === 200) {
            this.publicHandle(res.data, this.material);
          }
        });
    },

    // 4.3 课程资源建设占比进度跟踪
    materialResourcesDom() {
      this.$axios
        .post(
          this.$apiurls.getConstructionProgressOfParticipatingInstitutionEcharts,
          {
            echartsType: 10,
            name: this.header.courseName,
            type: 2,
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          if (res.code === 200) {
            this.publicHandle(res.data, this.materialResources);
          }
        });
    },

    publicHandle(data, newobj) {
      let realValue = [];
      let targetValue = [];
      let nameList = [];
      for (let i = 0; i < data.length; i++) {
        if (!data[i].value) {
          data[i].value = {};
          data[i].value.realValue = 0;
          data[i].value.targetValue = 0;
        } else {
          if (!data[i].value.realValue) {
            data[i].value.realValue = 0;
          }
          if (!data[i].value.targetValue) {
            data[i].value.targetValue = 0;
          }
        }
        realValue.push(data[i].value.realValue);
        targetValue.push(data[i].value.targetValue);
        if (data[i].name.indexOf("占比") !== -1) data[i].name = data[i].name.replace("占比", "");
        if (data[i].name.indexOf("素材资源") !== -1)
          data[i].name = data[i].name.replace("素材资源", "");
        nameList.push(data[i].name);
      }
      newobj.dataList = [realValue, targetValue];
      newobj.transverseData = nameList;
    },
  },
};
</script>

<style scoped>
.export {
  position: absolute;
  right: 10px;
  top: 10px;
  z-index: 1;
}

.analysisReport {
  width: 100%;
  background: #fff;
}

h1,
h2,
h3,
h4,
h5,
p {
  margin: 0px;
  padding: 0px;
}

.analysisReport_box {
  /* width: 70%;
  margin: 0px auto;
  height: 13700px; */
}

.header_titles {
  display: flex;
  justify-content: center;
  flex-flow: column;
  color: #000;
  text-align: center;
  position: relative;
}

.header_titles h1 {
  font-size: 45px;
  font-weight: bold;
  color: #1d244e;
}

.number_time {
  margin: 40px 0 20px 0;
}

.number_time div {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #707f9d;
  font-size: 1.5625rem;
}

.number_time p {
  width: 100%;
  height: 0.0625rem;
  background: #707f9d;
  margin-top: 0.5rem;
}

.number_time p:last-child {
  opacity: 0.5;
  margin-top: 0.25rem;
}

.download {
  width: 80px;
  background: #3d8cff;
  border: 1px solid #3d8cff;
  position: absolute;
  top: 15px;
  right: 0px;
}

.division {
  position: relative;
  clear: both;
  text-align: center;
  font-weight: bold;
  font-size: 44px;
  color: #1d244e;
  margin: 35px 0 30px 0;
}

.basic {
  display: flex;
  flex-flow: column;
  text-indent: 40px;
  line-height: 28px;
  font-size: 17px;
  color: #707f9d;
}

.biaoge {
  width: 95%;
  margin: 10px auto 0px;
}

.biaoge .twoTable {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.course {
  text-align: center;
  margin: 0px 10px;
}

.course tr {
  height: 35px;
  color: #707f9d;
  font-size: 15px;
}

.course tr:nth-child(2n) {
  background: #fff;
  color: #566178;
}

.course tr:nth-child(2n-1) {
  background: #7ed2ff;
  color: #566178;
}

.course tr:first-child {
  background: #66adff;
  color: #fff;
}

.chart_box h4 {
  font-weight: 700;
  font-size: 42px;
  color: #1d244e;
  line-height: 100px;
}

.chart_box p {
  font-size: 35px;
  text-indent: 2em;
  line-height: 60px;
  color: #707f9d;
}

.chart_box .echartsHeight {
  width: 80%;
  height: 28rem;
  margin: 0px auto;
}

.chart_box .chart_name {
  text-align: center;
  font-size: 30px;
  color: #707f9d;
}

.chart_box .notes {
  margin: 35px;
  line-height: 25px;
  font-size: 14px;
  color: #707f9d;
}

.creditRanking {
  display: flex;
  justify-content: space-between;
  font-size: 17px;
  text-indent: 40px;
  line-height: 28px;
  color: #707f9d;
}
</style>

<style>
::-webkit-scrollbar {
  width: 10px !important;
  height: 14px;
  border-radius: 3px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  background-color: #c1c1c1 !important;
  border-radius: 3px;
}
</style>
<style lang="scss" scoped>
.page-box {
  // padding: 7% 0;
  // height: 2740px;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;

  // border: 1px solid red;
  .m-top150 {
    margin-top: 150px;
  }

  .m-top100 {
    margin-top: 100px;
  }

  .biaoge {
    width: 95%;
    margin: 25px auto;

    .course {
      text-align: center;
      margin: 0px 10px;

      tr {
        height: 42px;
        color: #707f9d;
        font-size: 22px;

        &:nth-child(2n) {
          background: #fff;
          color: #566178;
        }

        &:nth-child(2n-1) {
          background: #7ed2ff;
          color: #566178;
        }
      }
    }
  }
}

.flex-box {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  & > div {
    flex: 1;
    display: flex;
    flex-direction: column;
  }
}

.right {
  float: right;
  margin-right: 20px;
  font-size: 32px;
}
</style>
